import React, {PureComponent} from 'react';
import toastr from 'toastr';
import http from "../../../services/httpService";
import {getJwt} from "../../../services/authService";
import InputRegular from "../../common/InputRegular";

class Security extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            fieldsCheckActive: false,
            passwordsNotMatch: false,
            data: {
                current_password: "",
                new_password: "",
                repeat_new_password: ""
            },
            userId: this.props.user ? this.props.user.id : '',
            errors: {},
            errorsList: []
        };

    }

    handleResetPassword = () => {
        this.setState({
            data: {
                current_password: "",
                new_password: "",
                repeat_new_password: ""
            }
        })
    }
    updateErrorsList = async (error, id) => {
        await this.setState({passwordsNotMatch: false})
        //console.log('update error list error: ', error)
        //console.log('update error list id: ', id)

        let errorsList = await this.state.errorsList;

        //console.log('state errorsList: ', this.state.errorsList)
        //console.log('let errorsList: ', errorsList)

        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
    }
    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
    doSubmit = async () => {
        //console.log('entered doSubmit')
        await this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')

            //console.log('anyErrorActive: ', anyErrorActive);

            if (
                !anyErrorActive &&
                this.state.data.current_password &&
                this.state.data.new_password &&
                this.state.data.repeat_new_password
            ) {

                //console.log('error list empty')

                const {new_password, repeat_new_password} = this.state.data;
                if (new_password !== repeat_new_password) {
                    //console.log('passwords do not match')
                    this.setState({
                        passwordsNotMatch: true
                    })
                } else {
                    //console.log('passwords match')
                    await this.setState({
                        spinnerActive: true
                    })
                    let data = {
                        old_password: this.state.data.current_password,
                        new_password: this.state.data.new_password
                    }
                    try {
                        //console.log('change passwords call: ', 'api/user/' + this.state.userId + '/password')
                        //console.log('change passwords call data: ', data)
                        const result = await http.patch('api/user/' + this.state.userId + '/password', data, {headers: {authorization: getJwt()}});
                        let message;
                        //console.log('pass change result: ', result)

                        await this.setState({
                            spinnerActive: false
                        })
                        if (result.data.message === 'new password parameter does not exists' || result.data.message === 'old password parameter does not exists' || result.data.message === 'old password is incorrect') {

                            // console.log('enter pass response message')
                            message = this.capitalize(result.data.message)
                            if (result.data.message === 'old password is incorrect') {
                                // console.log('old pass is incorrect ')
                                toastr.error('Error Code #10049: Incorrect current password. Check your current password and try again')
                            } else {
                                toastr.error('Error Code #10050: '+message)
                            }
                        } else {
                            toastr.success('Your password has been successfully changed!');
                        }

                    } catch (e) {

                        await this.setState({
                            spinnerActive: false
                        })
                        toastr.error('Error Code #10051: Something went wrong... Please try again.')
                    }

                }
            }
        }, 500)
    };

    render() {
        return (
            <div className='panel-container profile-tab'>

                <h3>Security</h3>

                <InputRegular
                    id="1"
                    label1="Current Password"
                    label2=""
                    placeholder="********"
                    type='password'
                    onChange={async (value) => await this.setState({
                        data: {
                            ...this.state.data,
                            current_password: value
                        }
                    })}
                    value={this.state.data.current_password}
                    required={true}
                    fieldsCheckActive={this.state.fieldsCheckActive}
                    updateErrorsList={this.updateErrorsList}
                    errorMessage="Password must contain minimum 8 characters. At least one character should be a number (0-9) or a special character."
                    spaceBellowInput={30}
                />
                <InputRegular
                    id="2"
                    label1="New Password"
                    label2=""
                    placeholder="********"
                    type='password'
                    onChange={async (value) => await this.setState({
                        data: {
                            ...this.state.data,
                            new_password: value
                        },
                        // passwordsNotMatch: false

                    })}
                    value={this.state.data.new_password}
                    required={true}
                    fieldsCheckActive={this.state.fieldsCheckActive}
                    updateErrorsList={this.updateErrorsList}
                    errorMessage="Password must contain minimum 8 characters. At least one character should be a number (0-9) or a special character."
                    spaceBellowInput={30}
                />
                <InputRegular
                    id="3"
                    label1="Repeat New Password"
                    label2=""
                    placeholder="********"
                    type='password'
                    onChange={async (value) => await this.setState({
                        data: {
                            ...this.state.data,
                            repeat_new_password: value
                        },
                        // passwordsNotMatch: false
                    })}
                    value={this.state.data.repeat_new_password}
                    required={true}
                    fieldsCheckActive={this.state.fieldsCheckActive}
                    updateErrorsList={this.updateErrorsList}
                    errorMessage="Password must contain minimum 8 characters. At least one character should be a number (0-9) or a special character."
                    spaceBellowInput={30}
                />
                {this.state.passwordsNotMatch ?
                    <div className="passwords-match-container">
                        Passwords do not match!
                    </div>
                    :
                    ''
                }
                <div className='flex-row edit-profile-tab-buttons'>
                    <button
                        disabled={this.state.data.current_password === '' && this.state.data.new_password === '' && this.state.data.repeat_new_password === ''}
                        onClick={this.handleResetPassword}

                        type="button"
                        className='btn-white-border'>Cancel
                    </button>


                    <button
                        disabled={this.state.spinnerActive}
                        type="button"
                        onClick={this.doSubmit}

                        className={this.state.spinnerActive ? 'btn-action' : 'btn-action'}>
                        {
                            this.state.spinnerActive ?
                                <React.Fragment>
                                    Save
                                    <i className='fa fa-spin fa-spinner'></i>
                                </React.Fragment>
                                :
                                'Save'
                        }

                    </button>

                </div>
            </div>
        )
    }
}

export default Security;